module.exports = {
	"ha": "vcha",
	"id": 2.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Vancouver Coastal Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018,
					2019
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2668.8252301156476,
					2668.3267329967225,
					2773.4653479678504,
					3244.1177305367128,
					4005.4977419988218,
					6261.767322533258,
					7958.22953281234,
					8258.86466294576,
					8627.917308276854,
					7151.007233027851,
					{
						"y": 5813.850557189366,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1762.2769885994753,
					1839.7886874198507,
					1909.957681129863,
					2443.3022091101716,
					3069.5660928219068,
					8081.816653979615,
					8780.333788843776,
					9253.515700250433,
					8384.274551631137,
					8906.611188164587,
					{
						"y": 9489.94928098877,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					5486.936589882124,
					5494.87249698871,
					5770.402788035886,
					7886.119279757321,
					11130.645067836873,
					12321.833276223797,
					13574.745021275581,
					13628.236803729435,
					13440.702482656145,
					13908.856619495311,
					{
						"y": 14225.036395508816,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					4125.44439174856,
					4140.310731825397,
					4338.929913622318,
					5770.392212590593,
					7942.486922065867,
					10062.866461891419,
					11329.734087488261,
					11514.853625744034,
					11338.517702496498,
					11327.856925189799,
					{
						"y": 11279.918706818098,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_2_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_2_1.json
// module id = 290
// module chunks = 0